module.exports = __webpack_public_path__ + "img/audio.886514cc.svg";